import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { SbRespSortItems } from '../../finding/SbRespSortItems/SbRespSortItems.tsx';
import { SharedFollowTopButton } from '../../shared/SharedFollowTopButton/SharedFollowTopButton.tsx';
import { SbRespRefineTopAppliedFilters } from '../../finding/SbRespRefineTopNav/SbRespRefineTopAppliedFilters.tsx';
import { type BuyRespTopNav_buyPage$key } from './__generated__/BuyRespTopNav_buyPage.graphql.ts';
import { type BuyRespTopNav_user$key } from './__generated__/BuyRespTopNav_user.graphql.ts';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

const buyPageFragment = graphql`
    fragment BuyRespTopNav_buyPage on ItemSearchQueryConnection {
        ...SharedFollowTopButton_itemSearch
        ...SbRespRefineTopAppliedFilters_itemSearch
        ...SbRespSortItems_itemSearch
    }
`;

const userFragment = graphql`
    fragment BuyRespTopNav_user on User {
        ...SharedFollowTopButton_user
        ...SbRespRefineTopAppliedFilters_user
        ...SbRespSortItems_user
    }
`;

type Props = {
    buyPage: BuyRespTopNav_buyPage$key;
    user: BuyRespTopNav_user$key | null | undefined;
    hideSaveSearchButton?: boolean;
};

export const BuyRespTopNav: FC<Props> = ({
    buyPage: buyPageRef,
    user: userRef,
    hideSaveSearchButton = false,
}) => {
    const buyPage = useFragment(buyPageFragment, buyPageRef);
    const user = useFragment(userFragment, userRef);
    return (
        <div className={dibsCss.mtMedium}>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.pbSmall,
                    dibsCss.mbSmall,
                    hideSaveSearchButton ? dibsCss.justifyEnd : dibsCss.justifyBetween
                )}
            >
                {!hideSaveSearchButton && (
                    <SharedFollowTopButton itemSearch={buyPage} user={user} />
                )}
                <div
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.itemsCenter,
                        dibsCss.sassyFontBodySizeSmall
                    )}
                >
                    <SbRespSortItems user={user} itemSearch={buyPage} />
                </div>
            </div>
            <SbRespRefineTopAppliedFilters itemSearch={buyPage} user={user} />
        </div>
    );
};
